export default "__VITE_ASSET__22abf27f__"